import {
  determinePlantProfileChanges,
  UnsavedPlantProfile,
} from "portal/utils/categoryCollection/plantProfile";
import { PlantProfileList } from "portal/components/categoryCollectionProfile/PlantProfileList";
import { portalEndpoints } from "portal/state/portalApi";
import { useMutationPopups } from "portal/utils/hooks/useApiPopups";
import { useTranslation } from "react-i18next";
import React, { FC, useCallback } from "react";

export const AdminPlantProfileList: FC = () => {
  const { t } = useTranslation();
  const [applyPlantProfileChanges] = useMutationPopups(
    portalEndpoints.applyGlobalPlantProfileChanges.useMutation(),
    {
      success: t("utils.actions.createdLong", {
        subject: t(
          "models.categoryCollectionProfiles.categoryCollectionProfile_title_one"
        ),
      }),
    }
  );

  const onCreateProfile = useCallback(
    (unsavedPlantProfile: UnsavedPlantProfile) =>
      applyPlantProfileChanges({
        ccUUID: unsavedPlantProfile.id,
        changes: determinePlantProfileChanges(undefined, unsavedPlantProfile),
      }),
    [applyPlantProfileChanges]
  );

  return (
    <PlantProfileList
      isAdmin
      useLazyListQuery={portalEndpoints.listGlobalPlantProfiles.useLazyQuery}
      onCreateProfile={onCreateProfile}
    />
  );
};
